import React from 'react';
import MobileViewPort from 'assets/img/mobile-viewport.svg';
import "./style.scss";

export function RootContainer(props) {

    const NoAvailabaleViewTemplate = () => {
        return <div className="mobile-viewport-content m-5 text-center">
            <img src={MobileViewPort} className="img-fluid mx-auto" alt="img" />
            <h4 className="mt-5">
                <i className="bi bi-exclamation-circle" style={{ fontSize: "35px" }} /> <br />
                Sorry, actually no responsive version to the mobile view port!
            </h4>
        </div>
    }

    return (
        <>
            <div className="root-content">
                <div className="wrapper d-flex align-items-stretch">
                    {props.children}
                </div>
            </div>
            <NoAvailabaleViewTemplate />
        </>
    );
}